import React, { useState, useEffect } from 'react';
import { StldInput } from '../../styled-components/StyledInput.style';

export const DynamicInputPME = React.forwardRef(({ label, name, placeholder, value, className = null, style = null, color = null, paramMethod = null }, ref) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleBlur = () => {
        if (paramMethod) paramMethod(inputValue);
    };

    return (
        <StldInput color={color} >
            <label className="focused">{label}</label>
            <input
                ref={ref}
                name={name}
                className={className}
                style={style}
                type="text"
                placeholder={placeholder}
                value={inputValue}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        </StldInput>
    );
});

